export interface ProgramCodeBookSearch {
  name: string;
  programTypeIds: number[];
  educationSectorIds: number[];
}

export const programCodeBookSearchInitial = (): ProgramCodeBookSearch => {
  return {
    name: "",
    programTypeIds: [],
    educationSectorIds: []
  }
}